import vi from 'element-plus/es/locale/lang/vi';
import { createApp } from 'vue';
import App from './App.vue';
import VueHtmlToPaper from './plugins/VueHtmlToPaper.js';

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import i18n from '@/core/plugins/i18n';
import ElementPlus from 'element-plus';
import router from './router';
import store from './store';

//imports for app initialization
import ApiService from '@/core/services/ApiService';
// import { initApexCharts } from "@/core/plugins/apexcharts";
import { initGlobalDatePicker } from '@/core/plugins/date-picker';
import { initInlineSvg } from '@/core/plugins/inline-svg';
import { initVeeValidate } from '@/core/plugins/vee-validate';
import { initVueQuery } from '@/core/plugins/vue-query';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import {
    faArrowLeft,
    faArrowRight,
    faCheck,
    faCheckSquare,
    faCircleInfo,
    faCircleNotch,
    faEraser,
    faFileCirclePlus,
    faFileCircleXmark,
    faFileExport,
    faFileImport,
    faFloppyDisk,
    faList,
    faMinus,
    faPenToSquare,
    faPlus,
    faPrint,
    faReceipt,
    faRefresh,
    faRightToBracket,
    faSpinner,
    faSquare,
    faTrash,
    faTriangleExclamation,
    faWrench,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

/* import specific icons */

import vCan from '@/core/directives/v-can';
import dialogAutoFocus from '@/core/directives/dialogAutoFocus';
import excludeTabOrder from '@/core/directives/excludeTabOrder';
import '@/core/plugins/prismjs';
import 'bootstrap';
import './assets/css/main.css';

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

library.add(
  faFloppyDisk,
  faArrowLeft,
  faTrash,
  faXmark,
  faArrowRight,
  faPlus,
  faCircleInfo,
  faPenToSquare,
  faCircleQuestion,
  faTriangleExclamation,
  faSpinner,
  faCircleNotch,
  faRightToBracket,
  faFileImport,
  faFileExport,
  faMinus,
  faPrint,
  faFileCirclePlus,
  faCheckSquare,
  faSquare,
  faWrench,
  faReceipt,
  faFileCircleXmark,
  faList,
  faEraser,
  faCheck,
  faRefresh
);

app.component('font-awesome-icon', FontAwesomeIcon);

// Register v-can directive
app.directive('can', vCan);
app.directive('dialog-auto-focus', dialogAutoFocus);
app.directive('exclude-tab-order', excludeTabOrder);

app.use(store);
app.use(router);
app.use(ElementPlus, { size: 'medium', zIndex: 3000, locale: vi });
initGlobalDatePicker(app);
app.use(VueHtmlToPaper);

ApiService.init(app);
// initApexCharts(app);
initVueQuery(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount('#app');

export default app;
